import { configureStore } from '@reduxjs/toolkit'
import formsSlice from './features/counter/formsSlice'
import godSlice from './features/god/godSlice'
import darkModeSlice from './features/darkMode/darkModeSlice'
import permissionsSlice from './features/permissions/permissionsSlice'

export default configureStore({
  reducer: {
    forms: formsSlice,
    god: godSlice,
    dark_mode: darkModeSlice,
    permissions: permissionsSlice,
  },
})